import { defineComponent, reactive, toRefs, computed } from 'vue';
import { useNewsList } from '../hooks/use-news-list';
import { useNewsOneShow } from '../hooks/use-news-one-show';
import NewsListShow from '../../../newsList/index';
export default defineComponent({
  components: {
    NewsListShow
  },
  setup() {
    const {
      newsCards_one,
      newsCards_two
    } = useNewsList();
    const {
      newsCards
    } = useNewsOneShow();
    const newsGather = reactive({
      newsCards_one,
      newsCards_two,
      newsCards
    });
    return {
      ...toRefs(newsGather)
    };
  }
});